import React, { useState } from 'react'
import { ContentCon, HubTabsHead } from './styles'
import { TabPanel } from '../../../Components/Tab/TabPanel'
import { EventGQL, EventHubData, EventHubExperience } from '../../../Api'
import { Gameday } from './Gameday'
import { MatchupSlider } from '../matchupSlider'
import { Tab } from '../../../Components/LazyComponents'
import { Experiences } from './experiences/Experiences'
import { logEvent } from 'Utils'
import { ANALYTICS_TAGS } from 'Constant'

type HubTabsParams = {
  hubInfo: EventHubData | null
  events: EventGQL[]
  handleExperienceSelected: (experience: EventHubExperience) => void
}

export const HubTabs: React.FC<HubTabsParams> = ({
  hubInfo,
  events,
  handleExperienceSelected,
}) => {
  const [value, setValue] = useState(0)

  const hubTabOptions = ['Experiences', 'Event Info', 'Schedule']

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    logEvent(ANALYTICS_TAGS.gameday_hub_tab_change, {
      tab_index: newValue,
      tab_name: hubTabOptions[newValue],
    })
    setValue(newValue)
  }

  return (
    <>
      <HubTabsHead
        value={value}
        onChange={handleChange}
        aria-label="transactions tabs"
        indicatorColor="primary"
      >
        {hubTabOptions.map((option) => (
          <Tab key={option} label={option} />
        ))}
      </HubTabsHead>
      <TabPanel value={value} index={0}>
        <ContentCon>
          <Experiences
            experiences={hubInfo?.experiences || []}
            handleExperienceSelected={handleExperienceSelected}
          />
        </ContentCon>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ContentCon>
          <Gameday hubInfo={hubInfo} />
        </ContentCon>
      </TabPanel>
      <TabPanel value={value} index={2}>
        {events?.length > 0 && (
          <ContentCon>
            <MatchupSlider events={events} />
          </ContentCon>
        )}
      </TabPanel>
    </>
  )
}
